/* src/app/components/add-edit-portfolio/add-edit-portfolio.component.scss */
.execution-wrapper {
  display: flex;
  height: calc(100vh - 96px);
  overflow: hidden;
}
.execution-wrapper app-execution-sidebar {
  flex: 0 0 33.75rem;
  max-width: 33.75rem;
}
.container-tool {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding: 3.5rem 16%;
}
.container-tool h1 {
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 300;
  color: #2e2e38;
}
.container-tool .description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
  margin: 1.5rem 0 0 0;
}
.container-tool .title-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
  margin-bottom: 2rem;
}
.container-tool .title-info .title {
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #72727f;
  margin: 0;
}
.container-tool .title-info .create-aggregation {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: #155cb4;
  margin: 0;
}
/*# sourceMappingURL=add-edit-portfolio.component.css.map */
